import React from 'react';
import './Services.css';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Services = () => {
  const services = [
    {
      id: 'digital-transformation',
      title: 'Digital Transformation',
      description: 'Modernize legacy systems and processes with cloud-native architectures and automation.',
      link: '/solutions/digital-transformation'
    },
    {
      id: 'ai-ml',
      title: 'AI & Machine Learning',
      description: 'Implement intelligent automation and predictive analytics to drive innovation.',
      link: '/solutions/ai-ml'
    },
    {
      id: 'web-development',
      title: 'Web Application Development',
      description: 'Scalable web applications built with React, Node.js,Springboot and modern frameworks.',
      link: '/solutions/web-development'
    },
    {
      id: 'mobile-apps',
      title: 'Mobile Application Development',
      description: 'Native and cross-platform mobile solutions for iOS and Android.',
      link: '/solutions/mobile-apps'
    },
    {
      id: 'Desktop-apps',
      title: 'Desktop Application Development',
      description: 'Command-based and Gui solutions for Windows, Linux and MacOs.',
      link: '/solutions/desktop-apps'
    }
  ];

  const industries = [
    { name: 'Healthcare', description: 'HIPAA-compliant systems and patient management solutions' },
    { name: 'Financial Services', description: 'Secure banking platforms and payment processing' },
    { name: 'Retail & E-commerce', description: 'Omnichannel retail and inventory management' },
    { name: 'Manufacturing', description: 'IoT integration and supply chain optimization' },
    { name: 'Education', description: 'Learning management and student information systems' },
    { name: 'Government', description: 'Secure public sector applications and data management' }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Enterprise Technology Services</h1>
          <p>
            We deliver end-to-end software solutions that drive digital transformation 
            and operational excellence for organizations across industries.
          </p>
        </div>
      </section>

      <section className="services-main">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <p>Comprehensive technology solutions tailored to your business objectives</p>
          </div>

          <div className="services-grid">
            {services.map(service => (
              <Link to={service.link} key={service.id} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="service-link">
                  Learn more <ArrowForwardIcon sx={{ fontSize: 16 }} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="industries-section">
        <div className="container">
          <div className="section-header">
            <h2>Industry Expertise</h2>
            <p>Specialized solutions for regulated and complex business environments</p>
          </div>

          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-item">
                <h3>{industry.name}</h3>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Approach</h2>
            <p>Proven methodology for delivering successful technology projects</p>
          </div>

          <div className="approach-grid">
            <div className="approach-step">
              <div className="step-number">01</div>
              <h3>Discovery & Planning</h3>
              <p>Requirements analysis, technical assessment, and project roadmap development.</p>
            </div>
            <div className="approach-step">
              <div className="step-number">02</div>
              <h3>Design & Architecture</h3>
              <p>System design, technology selection, and security architecture planning.</p>
            </div>
            <div className="approach-step">
              <div className="step-number">03</div>
              <h3>Development & Testing</h3>
              <p>Agile development with continuous integration and comprehensive QA testing.</p>
            </div>
            <div className="approach-step">
              <div className="step-number">04</div>
              <h3>Deployment & Support</h3>
              <p>Production deployment, monitoring, and ongoing maintenance and optimization.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>Schedule a consultation to discuss your technology requirements and objectives.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
